/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { Topic } from '@jira/servicedesk__knowledge-common/src/CategoryGuid.types.tsx';

export const removeTopic = (topics: Topic[], topicId: string): Topic[] =>
	topics.filter((topic) => topic.topicId !== topicId);
